<template>
  <DialogBase
    v-model="showRescheduleTripForm"
    width="60vh"
    :title="`Reschedule ${orderName.trip}`"
  >
    <template #dialogContent>
      <v-form
        v-model="isValid"
        ref="rescheduleTripForm"
        @submit.prevent="rescheduleTrip"
      >
        <v-row class="mx-0 mb-0 mt-6">
          <v-col cols="12">
            <InputField
              id="date"
              type="date"
              v-model="tripDetails.date"
              name="date"
              :min="returnToday(1)"
              :label="`${orderName.trip} Date*`"
              :rules="[(val) => !!val || `${orderName.trip} Date is required`]"
              :error-messages="formErrors.date"
              @input="delete formErrors.date"
            />
          </v-col>
          <v-col cols="12">
            <SelectField
              id="reason"
              v-model="tripDetails.reason"
              label="Reason*"
              name="reason"
              :itemsList="tripRescheduleReasonsList"
              itemText="name"
              itemValue="id"
              :rules="[(val) => !!val || 'Reason is required']"
              :error-messages="formErrors.reason"
              @input="delete formErrors.reason"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #dialogActions>
      <v-btn
        id="rescheduleTripSubmit"
        depressed
        color="primary"
        :disabled="!isValid"
        @click="rescheduleTrip"
        >Submit</v-btn
      >
    </template>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/BaseComponents/DialogBase.vue";
import { returnToday } from "@/utils/functions";
import { tripModule } from "@/utils/moduleMapping";
import { bus } from "@/main.js";

export default {
  emits: ["refreshList"],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tripModule: {
      type: String,
      required: true,
    },
    tripMethod: {
      type: String,
      required: true,
    },
    tripParentObj: {
      type: Object,
      required: true,
    },
  },
  components: { DialogBase },
  data() {
    return {
      returnToday,
      orderName: { ...tripModule },
      tripDetails: {},
      isValid: true,
      formErrors: {},
      tripRescheduleReasonsList: [],
    };
  },
  computed: {
    showRescheduleTripForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(val) {
      if (!val) {
        this.tripDetails = {};
        this.formErrors = {};
        this.$refs.rescheduleTripForm.reset();
      } else {
        let inter = setInterval(() => {
          if (this.$refs.rescheduleTripForm) {
            clearInterval(inter);
            this.$refs.rescheduleTripForm.resetValidation();
          }
        });
        this.getTripRescheduleReasonsList();
      }
    },
  },
  methods: {
    getTripRescheduleReasonsList() {
      bus.$emit("showLoader", true);
      this.$api.fieldConfiguration
        .getFieldConfigurationList({
          limit: "all",
          keyword: "Reschedule",
          module: "Trip",
        })
        .then((res) => {
          this.tripRescheduleReasonsList = res.data.map(
            (reason) => reason.name
          );
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    rescheduleTrip() {
      if (!this.$refs.rescheduleTripForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      let payload = {
        id: [this.tripParentObj.id],
        ...this.tripDetails,
      };
      bus.$emit("showLoader", true);
      this.$api[this.tripModule]
        [this.tripMethod](payload)
        .then(() => {
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "Trip rescheduled successfully",
            color: "success",
          });
          this.showRescheduleTripForm = false;
          this.$emit("refreshList");
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.error(err);
          this.formErrors = err.data;
        });
    },
  },
};
</script>

<style></style>
